import { z } from "zod";

export const getSubstitutionPlanFormQuerySchema = z.object({
	initialize: z.preprocess((val) => {
		if (val === "false") return false;
		if (val === "true") return true;
		return val;
	}, z.boolean().default(false)),
	copyPrevious: z.preprocess((val) => {
		if (val === "false") return false;
		if (val === "true") return true;
		return val;
	}, z.boolean().default(false)),
});

export type GetSubstitutionPlanFormQuerySchema = z.infer<typeof getSubstitutionPlanFormQuerySchema>;
